import React from 'react';
import { Dialog, DialogContent, DialogTitle, LinearProgress, Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

const DeleteProgressDialog = ({ open, current, total }) => {
    const pct = total > 0 ? Math.round((current / total) * 100) : 0;

    return (
        <Dialog open={open} maxWidth="xs" fullWidth disableBackdropClick disableEscapeKeyDown>
            <DialogTitle disableTypography>
                <Typography variant="h6" style={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <DeleteIcon style={{ color: '#c62828', marginRight: 6 }} />
                    Eliminando artículos...
                </Typography>
            </DialogTitle>

            <DialogContent style={{ paddingBottom: 28 }}>
                <Typography
                    variant="h5"
                    align="center"
                    style={{ fontWeight: 700, marginBottom: 16, color: '#c62828', letterSpacing: 1 }}
                >
                    {current}
                    <span style={{ color: '#9e9e9e', fontWeight: 400 }}> / {total}</span>
                </Typography>

                <LinearProgress
                    variant="determinate"
                    value={pct}
                    style={{ height: 10, borderRadius: 5, backgroundColor: '#ffcdd2' }}
                />

                <Typography variant="body2" align="center" style={{ marginTop: 8, color: '#757575' }}>
                    {pct}%
                </Typography>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteProgressDialog;
